<app-chip [color]="style().color" [attr.data-testid]="'outcome-chip-' + outcome()">
  <span class="outcome-chip-inner flex flex-align-center gap-xs">
    <app-icon [name]="style().icon" [size]="14" />
    <span>{{ labelKey() | translate }}</span>
  </span>
</app-chip>
